'use strict';

var _ = require('lodash');
var DemandTransparencyDataRetrieverService = function DemandTransparencyDataRetrieverService($q, restangular, dataRetrieverService, constants, scenarioConstants) {
  function getDataRetriever(target, dataDim, metric, carrier, market, spos, classGroup, lastProcessedMoment, datesSelection, rtp) {
    var m = market.split('-');
    rtp = rtp < 0 ? 0 : rtp;
    // no bar was selected, the result from REST API should be empty
    if (_.isArray(datesSelection) && _.isEmpty(datesSelection)) {
      datesSelection = ['0001-01-01'];
    }
    var rqlQuery = 'carrier==' + carrier + ';origin==' + m[0] + ';destination==' + m[1] + ';significantPOS=="' + spos + '"' + ';classGroup=="' + classGroup + '"' + ';flowType=="' + dataDim.toUpperCase() + '"' + getDepartureDateQuery(lastProcessedMoment, datesSelection);
    return dataRetrieverService.getDataRetriever(constants.DEMAND_TRANSPARENCY_SCREEN, constants.DEMAND_TRANSPARENCY_UNTRUNCATED_MD_MODE, target).setCustomSearchCriteriaRules($q.when(rqlQuery)).setRequestParameters({
      'rtp': rtp
    }).updateMetricValues(metric);
  }
  function getDepartureDateQuery(lastProcessedMoment, datesSelection) {
    var rqlQuery = '';
    if (_.isArray(datesSelection)) {
      rqlQuery += ';(' + datesSelection.map(function (date) {
        return 'departureDate=="' + date + '"';
      }).join(',') + ')';
    } else {
      rqlQuery += ';departureDate=le="' + lastProcessedMoment.toISOString() + '"'; // Departure Dates <= lastProcessedDateTime
    }
    return rqlQuery;
  }
  function getForecastProfileDataRetriever(target, dataDimension, carrier, origin, destination, significantPOS, classGroup) {
    var modeType = dataDimension === 'regular' ? constants.DEMAND_TRANSPARENCY_FORECAST_PROFILE_REGULAR : constants.DEMAND_TRANSPARENCY_FORECAST_PROFILE_MAPPED;
    var params = {
      carrier: carrier,
      origin: origin,
      destination: destination,
      significantPOS: significantPOS,
      classGroup: classGroup,
      reachedMinObs: true,
      scenarioName: scenarioConstants.PUBLISHED
    };
    return dataRetrieverService.getDataRetriever(constants.DEMAND_TRANSPARENCY_SCREEN, modeType, target).setRequestParameters(params).setCustomSearchCriteriaRules($q.when()).localSortApplied();
  }
  function getForecastProfileChartData(dataDim, carrier, origin, destination, spos, classGroup) {
    return getForecastProfileDataRetriever(constants.DTD_FORECAST_PROFILE_CHART, dataDim, carrier, origin, destination, spos, classGroup).retrieveComponentData(constants.DTD_FORECAST_PROFILE_CHART);
  }
  function getForecastDataGridDataRetriever(dataDim, carrier, origin, destination, spos, classGroup) {
    return getForecastProfileDataRetriever(constants.FORECAST_DATA, dataDim, carrier, origin, destination, spos, classGroup);
  }
  function getInitialForecastProfileData(dataDim, regularProfileLevel, mappedProfileLevel, serviceBussinesId) {
    var isRegular = dataDim === 'regular';
    var hepKeyProperty = isRegular ? regularProfileLevel : mappedProfileLevel;
    var hepType = isRegular ? 'RegularMarketInitDemandProfile' : 'MappedMarketInitDemandProfile';
    if (serviceBussinesId) {
      hepType = isRegular ? 'RegularServiceInitDemandProfile' : 'MappedServiceInitDemandProfile';
    }
    var params = {
      type: hepType,
      hepKey: '"' + hepKeyProperty + '"'
    };
    if (_.isUndefined(hepKeyProperty)) {
      return $q.all([]);
    }
    return dataRetrieverService.getDataRetriever(constants.DEMAND_TRANSPARENCY_SCREEN, constants.DEMAND_TRANSPARENCY_INITIAL_FORECAST_PROFILE, constants.DTD_FORECAST_PROFILE_CHART).setRequestParameters(params).setCustomSearchCriteriaRules($q.when()).localSortApplied().retrieveComponentData(constants.DTD_FORECAST_PROFILE_CHART);
  }
  function arrayWithSingleElement(array) {
    return _.isArray(array) && _.size(array) === 1;
  }
  function isOriginalRequest(filterData) {
    var originalAttrs = filterData.originalAttrs || {};
    return originalAttrs.classGroup === filterData.classGroup && arrayWithSingleElement(filterData.seasons) && originalAttrs.season === filterData.seasons[0] && arrayWithSingleElement(filterData.dows) && originalAttrs.dowGroup === filterData.dows[0];
  }
  function getForecastProfileData(attrs, filterData, dataDimension) {
    if (isOriginalRequest(filterData)) {
      return getInitialForecastProfileData(dataDimension, attrs.regularProfileLevel, attrs.mappedProfileLevel, attrs.serviceBusinessId);
    } else {
      var m = attrs.market.split('-');
      return getForecastProfileChartData(dataDimension, attrs.carrier, m[0], m[1], attrs.spos, filterData.classGroup);
    }
  }
  function getDtdChartDataRetriever(dataDim, metric, carrier, market, spos, classGroup, lastProcessedMoment, rtp) {
    return getDataRetriever(constants.DTD_CHART, dataDim, metric, carrier, market, spos, classGroup, lastProcessedMoment, undefined, rtp);
  }
  function getDtdGridDataRetriever(dataDim, metric, carrier, market, spos, classGroup, datesSelection) {
    return getDataRetriever(constants.DTD_MATRIX, dataDim, metric, carrier, market, spos, classGroup, undefined, datesSelection);
  }
  function getAllDataGridRetriever(dataDim, metric, carrier, market, spos, classGroup, datesSelection, lastProcessedMoment) {
    return getDataRetriever(constants.ALL_DATA, dataDim, metric, carrier, market, spos, classGroup, lastProcessedMoment, datesSelection);
  }
  function getAirportTimezoneOffset(origin) {
    return restangular.one('ancillary').one('airport').one('tzOffsets').one(origin).withHttpConfig({
      cache: true
    }).get();
  }
  return {
    getDtdChartDataRetriever: getDtdChartDataRetriever,
    getDtdGridDataRetriever: getDtdGridDataRetriever,
    getForecastProfileData: getForecastProfileData,
    getForecastDataGridDataRetriever: getForecastDataGridDataRetriever,
    getAllDataGridRetriever: getAllDataGridRetriever,
    getAirportTimezoneOffset: getAirportTimezoneOffset
  };
};
DemandTransparencyDataRetrieverService.$inject = ['$q', 'Restangular', 'DataRetrieverService', 'DataRetrieverConstantsService', 'ScenarioConstants'];
module.exports = DemandTransparencyDataRetrieverService;